export default "__VITE_ASSET___IVJOGlz__"